<template>
    <div :class="phoneClass || 'setting-wrapper'" @keyup.enter="updateInfo">
        <div class="login-header">
            <index-header>
                <div class="slot-content">
                    {{$t('header.register')}}
                </div>
            </index-header>
        </div>
        <content-header>
        </content-header>
        <div class="setting-content" >
            <div class="floor-title">
                <span class="title">{{$t("setting.basic_data")}}</span>
            </div>
            <div class="info-edit">
                <div class="info-floor">
                    <!--公司-->
                    <div class="floor-block">
                        <p>{{$t('setting.company')}}<span style="color: red">*</span></p>
                        <el-input v-model="editForm.company" :placeholder="$t('setting.company')"></el-input>
                    </div>
                    <div class="floor-block">
                        <p>{{$t('setting.profession')}}<span style="color: red">*</span></p>
                        <!--<el-input v-model="editForm.profession" :placeholder="$t('setting.profession')"></el-input>-->
                        <el-autocomplete
                                popper-class="my-autocomplete"
                                v-model="editForm.profession"
                                :fetch-suggestions="querySearchOne"
                                :placeholder="$t('setting.profession')"
                                @select="handleSelectOne">
                            <i
                                    class="el-icon-edit el-input__icon"
                                    slot="suffix"
                                    @click="handleIconClick">
                            </i>
                            <template slot-scope="props">
                                <div class="name">{{ props.item.value }}</div>
                                <span class="addr">{{ props.item.address }}</span>
                            </template>
                        </el-autocomplete>
                    </div>
                </div>
                <!--省市区/公司地址-->
                <!-- <div class="info-floor">
                    <div class="floor-block">
                        <p>{{$t('setting.district')}}<span style="color: red">*</span></p>
                        <el-cascader :options="regionData"
                                     v-model="pcc"
                                     style="width: 100%;"
                                     :placeholder="$t('setting.district')"
                                     :props="regionProps"
                                     @change="regionChange">
                        </el-cascader>
                    </div>
                    <div class="floor-block">
                        <p>{{$t("setting.address")}}<span style="color: red">*</span></p>
                        <el-input v-model="editForm.address" :placeholder="$t('setting.address')"></el-input>
                    </div>
                </div> -->
                <div class="info-floor">
                    <div class="floor-block">
                        <p>{{$t('setting.province')}}<span style="color: red">*</span></p>
                        <el-input v-model="editForm.province" :placeholder="$t('setting.pvce_place')"></el-input>
                    </div>
                    <div class="floor-block">
                        <p>{{$t('setting.city')}}<span style="color: red">*</span></p>
                        <el-input v-model="editForm.city" :placeholder="$t('setting.city_place')"></el-input>
                    </div>
                </div>
                <div class="info-floor">
                    <div class="floor-block">
                        <p>{{$t('setting.county')}}<span style="color: red">*</span></p>
                        <el-input v-model="editForm.county" :placeholder="$t('setting.county_place')"></el-input>
                    </div>
                    <div class="floor-block">
                        <p>{{$t('setting.address')}}<span style="color: red">*</span></p>
                        <el-input v-model="editForm.address" :placeholder="$t('setting.address')"></el-input>
                    </div>
                </div>
                <div class="info-floor">
                    <!--电话-->
                    <div class="floor-block">
                        <p>{{$t('setting.phone')}}<span style="color: red">*</span></p>
                        <el-input v-model="editForm.phone" :placeholder="$t('setting.phone')"></el-input>
                    </div>
                    <!--邮编-->
                    <div class="floor-block">
                        <p>{{$t('setting.postcode')}}<span style="color: red">*</span></p>
                        <el-input v-model="editForm.postcode" :placeholder="$t('setting.postcode')"></el-input>
                    </div>
                </div>
                <div class="info-floor">
                    <!--邮件通知频率-->
                    <div class="floor-block">
                        <p>{{$t('setting.email_rate')}}<span style="color: red">*</span></p>
                        <el-select v-model="editForm.emailFre" :placeholder="$t('setting.email_rate')" style="width:100%;">
                            <el-option
                                    v-for="item in emailRateList"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </div>
                    <div class="floor-block">
                        <p>{{$t('setting.email')}}<span style="color: red">*</span></p>
                        <el-input v-model="editForm.email" @change="check" :placeholder="$t('setting.email')"></el-input>
                    </div>
                </div>
                <div v-if="checkShow" style="color: red;position: relative;top: -15px;left: 15px;">{{msg}}</div>
                <div class="clause">
                    <template >
                        <!-- `checked` 为 true 或 false -->
                        <el-checkbox v-model="checked" @change="log"></el-checkbox>
                    </template>
                    <span >
                            {{$t('setting.Agreement')}}
                            <!--<span class="clause-page" @click="newPage('https://www.skf.com/cn/zh/footer/privacy-policy.html')">"{{$t("setting.privacy")}}"</span>-->
                            <span class="clause-page" @click="goPDFPage">{{$t("setting.privacy")}}"</span>
                            {{$t("setting.and")}}
                            <span class="clause-page" @click="newPage('https://www.skf.com/cn/zh/footer/terms-and-conditions.html')">"{{$t('setting.terms')}}"</span>
                    </span>
                </div>
                <div class="operation">
                    <el-button type="primary" @click="updateInfo">
                        {{$t('updateInfoPage.finish')}}
                    </el-button>
                    <el-button  @click="goRegister">
                        {{$t('updateInfoPage.back')}}
                    </el-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Core from 'core/core'
import IndexHeader from './layout/header'
import contentHeader from '../components/content-header'
import region from "core/region"
import {refresh} from "core/winSize"
import axios from 'axios';
import i18n from "@/locales";

export default {
    data() {
        return {
            phoneClass: '',
            isShowInfo: true,
            regionData: [],
	        editForm: {
                name: '',
                phone: '',
                province: '',
                city: '',
                country: '中国',     //中国
                company: '',     //公司
                postcode: '',    //邮编
                professions: [],  //行业
                profession: '',
                address: '',     //详细地址
                site: '',        //地区
                factory: '',     //工厂
                email: '',       //邮箱
                emailFre: '',    //邮箱通知频率
                dealer: '',       //经销商
                password: ''
            },
            pcc: [],
            regionProps: {
                value: 'name',
                label: 'name'
            },
            emailRateList: [
                {
                    value:'0',
                    label: i18n.t('selectData.setting.email.rate0')
                },
                {
                    value:'1',
                    label: i18n.t('selectData.setting.email.rate1')
                },
                {
                    value:'2',
                    label: i18n.t('selectData.setting.email.rate2')
                },
                {
                    value:'3',
                    label: i18n.t('selectData.setting.email.rate3')
                },
                {
                    value:'4',
                    label: i18n.t('selectData.setting.email.rate4')
                },
            ],
            options: [{label: 'HTML'}, {label: 'CSS'}, {label: 'JavaScript'}],
            value: [],
            checkShow: '',
            msg: '',
            checked: false
        };
    },
    components: {
        contentHeader,IndexHeader
    },
    created() {
	    refresh(this,'phoneClass-settingData');
	    window.onresize = function(){
		    setTimeout(function(){
			    refresh(this,'phoneClass-settingData');
		    },10)
	    };


    },
    mounted() {
        this.initRegion()
        // console.log(this.$route);
        // this.initEmailRate();
        this.editForm.email = window.localStorage.getItem('email')
        this.editForm.password=localStorage.getItem("password")
        this.initProfession()

    },
    methods: {
	    goPDFPage() {
		    let routeUrl = this.$router.resolve({
			    path: "/show-pdf?src=/pdf/privacy/数字化润滑器监控管理平台隐私条款.pdf",
		    });
		    window.open(routeUrl.href, '_blank');
	    },
        initRegion() {
	        axios
	        .get('/ext/region-code.json')
	        .then(response => {
		        this.regionData = response.data.zh
	        })
        },
        log(){
            // console.log(this.checked);
        },
        check(){
            if(this.editForm.email){
                let email = this.editForm.email;
	            let emailReg = Core.Const.EMAIL_REG
	            if( emailReg.test(email) ){
                    this.checkShow = false
                } else {
                    this.checkShow = true
                    this.$message.error('邮箱格式不正确');
                }
            } else {
                this.checkShow = true
                this.$message.error('请输入邮箱');
            }
        },
        regionChange(e) {
            let [province, city, county] = this.pcc
	        // console.log (this.regionData)
	        // console.log (this.pcc)
	        // console.log (e)
            this.editForm.province = province
            this.editForm.city = city.trim();
            this.editForm.county = county
        },
        initProfession(){
            Core.Api.Config.getIndustryList().then(res => {
                this.editForm.professions = res.application_list
                this.restaurantsOne = this.loadAllOne();
                // console.log(res,'industrys');
            })
        },
        querySearchOne(queryString, cb) {
                var restaurants = this.restaurantsOne;
                var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
                // 调用 callback 返回建议列表的数据
                cb(results);
        },

        createFilter(queryString) {
            return (restaurant) => {
                return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
            };
        },
        handleSelectOne() {

        },
        loadAllOne() {
            let arr=[]
            for (let x in this.editForm.professions) {
                arr.push({"value":this.editForm.professions[x].name})
            }
            // console.log(arr,'arr');
            return arr
        },
        handleIconClick(ev) {
            // console.log(ev);
        },
        // name: '',
        // phone: '',
        // country: '',
        // province: '',
        // city: '',
        // county: '',
        // address: '',
        // company: '',     //公司
        // postcode: '',    //邮编
        // profession: '',  //行业
        // site: '',        //地区
        // factory: '',     //工厂
        // email: '',       //邮箱
        // emailFre: '',    //邮箱通知频率
        // dealer: ''       //经销商
        updateInfo() {
            // console.log(1);
            let info = this.editForm
            // console.log(info);
            if(info.email && info.password && info.email && info.country && info.province &&
            info.city && info.county && info.company && info.profession &&info.address && (info.emailFre || info.emailFre === 0) && info.phone){
	            // if(info.phone.length !== 8 && info.phone.length>0){
	            //     if (info.phone.length !== 12) {
		        //         if(!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(info.phone))){
			    //             this.$message.error('手机号码有误，请重填');
			    //             return false;
		        //         }
	            //     }
	            // }
                if(this.checked){
                    this.check()

                    if (!this.checkShow){
                        Core.Api.User.register(info.email,info.password,info.email,info.phone,info.country,info.province,
                            info.city,info.county,info.address,info.company,info.profession,info.postcode,info.emailFre,localStorage.getItem('captcha_token'),localStorage.getItem('captcha_code') ).then((res)=>{
                            // window.localStorage.clear()
	                        localStorage.setItem('password','')
	                        localStorage.setItem('email','')
	                        localStorage.setItem('captcha_token','')
	                        localStorage.setItem('captcha_code','')
                            let { user, token } = res;
                            Core.Data.setToken(token);
                            Core.Data.setUser(user);
                            this.$message.success('注册成功');
                            console.log(res,'注册成功');
                            this.$router.push('/home')
                        }).catch(() => {
                            localStorage.setItem('captcha_token','')
                            localStorage.setItem('captcha_code','')
                            this.$router.push('/register?type=1')
                        })
                    }
                } else {
                    this.$message.error(i18n.t('setting.privacy_terms_agreement'));
                }
            } else {
                this.$message.error(i18n.t('message.complete_information'));
            }
        },
        goRegister() {
            this.$router.push('/register');
        },
        newPage(page) {
            window.open(page)
        }
    },
}
</script>

<style scoped lang="scss">
@import '../assets/style/mixin.scss';

.setting-wrapper {
    background-color: #F7F9FA;
    min-height: 800px;
    height: 100vh;
    border-bottom: 1px solid transparent;
    .login-header {
        padding: 10px 0;
        background-color: #0f58d6;
        .slot-content {
            border-left: 1px solid rgba($color: #000000, $alpha: .3);
            display: inline-block;
            vertical-align: middle;
            font-size: 20px;
            color: #99BEFF;
            line-height: 26px;
            padding-left: 20px;
            font-weight: 500;
        }
    }
    .setting-content {
        margin: 30px 13vw;
        .floor-title {
            @include flex-sb;
            margin-bottom: 20px;
            .title {
                font-weight: 500;
                font-size: 20px;
                color: #363D42;
            }
            .my-button {
                border-color: #0F58D6;
                .icon {
                    width: 16px;
                    height: 16px;
                    vertical-align: middle;
                }
                .text {
                    font-size: 14px;
                    color: #0F58D6;
                    vertical-align: middle;
                    line-height: 20px;
                    margin-left: 6px;
                }
            }
        }
        .info-edit {
            .info-floor {
                margin-bottom: 20px;
                .floor-block {
                    display: inline-block;
                    width: calc(50% - 20px);
                    p {
                        margin-bottom: 6px;
                        font-size: 14px;
                        color: #7A8799;
                    }
                    &:first-child {
                        margin-right: 1.5vw;
                    }
                }
            }
            .operation {
                margin-top: 30px;
                .el-button {
                    padding: 9px 42px;
                }
            }
        }
    }
}


</style>
<style lang="scss">

    .setting-wrapper {
        .info-edit {
            .info-floor {
                width: 100%;
                .el-input {
                    height: 40px;
                    .el-input__inner {
                        height: 40px;
                    }
                }

                .floor-block {
                    width: 48% !important;
                    .el-autocomplete {
                        width: 100%;
                    }
                    .el-input__suffix-inner {
                        display: none;
                    }
                }
            }
            .clause {
                color: red;
                cursor:default;
                .clause-page {
                    color: blue;
                    cursor:pointer;
                }
                .is-checked{
                    .el-checkbox__inner {
                        background: red;

                        border: 1px red solid;
                    }
                }

            }

        }
    }
    .phoneClass-settingData {
        min-height: 100vh;
        background: #E5EBEF;
        width: 100vw;
        margin: 0;
        padding: 0;
        border: 1px solid transparent;
        .login-header {
            .slot-content {
                border-left: 1px solid rgba(0, 0, 0, 0.3);
                display: inline-block;
                font-size: 16px;
                color: #99BEFF;
                line-height: 26px;
                padding-left: 10px;
                font-weight: 400;
            }
        }
        .setting-content{
            width: 70%;
            margin: 15px auto;
            padding-bottom: 10px;
            .floor-title {
                span {
                    font-weight: 500;
                    font-size: 20px;
                    color: #363D42;
                }
            }
            .info-floor {
                .floor-block {
                margin-top: 3px;
                    >p {
                        margin-bottom: 0px;
                        font-size: 14px;
                        color: #7A8799;
                    }
                    .el-autocomplete {
                        width: 100%;
                        .el-input__suffix-inner {
                            display: none;
                        }
                    }
                }

            }
            .clause {
                color: red;
                cursor: default;
                margin-top: 10px;
                margin-bottom: 10px;
                .clause-page {
                    color: blue;
                    cursor:pointer;
                }
                .is-checked{
                    .el-checkbox__inner {
                        background: red;

                        border: 1px red solid;
                    }
                }
            }
        }
    }
</style>
